export default "__VITE_ASSET__CpEAVsiY__"